import React                       from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome';

class TooltipComponent extends React.Component {
  render() {
    if (!this.props.id || !this.props.title) {
      return null;
    }

    const tooltip = <Tooltip id={this.props.id} placement="top">
      {this.props.title}
    </Tooltip>;

    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <i>
          <FontAwesomeIcon icon={this.props.icon} id={this.props.id}/>
        </i>
      </OverlayTrigger>
    );
  }
}

TooltipComponent.defaultProps = {
  icon: ['fas', 'question-circle'],
};

export default TooltipComponent;
